export default {"src":"/_next/static/media/alert_large.04fdcc26.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};